import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ToiletsIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M9 5.5C9 6.32843 8.32843 7 7.5 7C6.67157 7 6 6.32843 6 5.5C6 4.67157 6.67157 4 7.5 4C8.32843 4 9 4.67157 9 5.5ZM9.2 13.2V11.5C9.2 10.5611 8.43888 9.8 7.5 9.8C6.56112 9.8 5.8 10.5611 5.8 11.5V13.2H9.2ZM7.5 8C5.567 8 4 9.567 4 11.5V13.2V15H5.2V20H7V15H8V20H9.8V15H11V13.2V11.5C11 9.567 9.433 8 7.5 8ZM15.5 20V17H16.5V20H18.3V17H20L19.8 15.2L19.3313 10.9817C19.1427 9.28419 17.7079 8 16 8C14.2921 8 12.8573 9.28419 12.6687 10.9817L12.2 15.2L12 17H13.7V20H15.5ZM17.5423 11.1804L17.9889 15.2H14.0111L14.4577 11.1804C14.545 10.3945 15.2093 9.8 16 9.8C16.7907 9.8 17.455 10.3945 17.5423 11.1804ZM16 7C16.8284 7 17.5 6.32843 17.5 5.5C17.5 4.67157 16.8284 4 16 4C15.1716 4 14.5 4.67157 14.5 5.5C14.5 6.32843 15.1716 7 16 7Z"
      />
    </SvgIcon>
  );
});
